<template>
  <div class="search-results">
    <div class="search-results-count">
      <p>
        <strong>{{ items.length }}</strong> {{ totalResultsLabel }} <strong>{{ query }}</strong>
      </p>
    </div>
    <ul class="search-results-list">
      <kf-search-results-item
        v-for="(item, i) in itemsToShow"
        :key="i"
        :item="item"
      />
    </ul>

    <kf-pagination
      v-if="showPagination"
      :total-items="items.length"
      :current-page="currentPage"
      :items-per-page="itemsPerPage"
      @changePage="handlePageChange"
    />
  </div>
</template>

<script>
import KfPagination from '@/components/search/Pagination.vue';
import KfSearchResultsItem from '@/components/search/SearchResultsItem.vue';

export default {
  name: 'KfSearchResults',
  components: {
    KfSearchResultsItem,
    KfPagination,
  },
  props: {
    i18n: {
      type: Object,
      default: null,
    },
    query: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
    itemsPerPage: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {
      currentPage: 1,
    };
  },
  computed: {
    totalResultsLabel() {
      return this.items.length === 1
        ? this.i18n.labels.totalresultssingle
        : this.i18n.labels.totalresults;
    },
    itemsToShow() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      return this.items.slice(startIndex, startIndex + this.itemsPerPage);
    },
    showPagination() {
      return this.items.length > this.itemsPerPage;
    },
  },
  methods: {
    handlePageChange(currentPage) {
      this.currentPage = currentPage;
    },
  },
};
</script>

<style lang="postcss">
.search-results {
  &-count {
    @apply mb-8 text-left;
  }

  &-list {
    @apply list-none;

    &-item {
      @apply mb-8 shadow-xs p-4 border border-gray-50 rounded-xs;

      a {
        @apply no-underline;
      }
    }
  }
}
</style>
